import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 14v-10","key":"svg-0"}],["path",{"d":"M12 14l4 -4","key":"svg-1"}],["path",{"d":"M12 14l-4 -4","key":"svg-2"}],["path",{"d":"M4 20h3m13 0h-3m-3.5 0h-3","key":"svg-3"}]]

const IconArrowBarToDownDashed = createReactComponent('outline', 'arrow-bar-to-down-dashed', 'ArrowBarToDownDashed', __iconNode);

export default IconArrowBarToDownDashed;